import { create } from 'zustand/react'

type DemoStore = {
  isDemo: boolean
  setIsDemo: (isDemo: boolean) => void
}

export const useDemoStore = create<DemoStore>()(set => ({
  isDemo: false,
  setIsDemo: (isDemo: boolean) => set({ isDemo }),
}))
